<template>
    <v-card height="100%">
      <v-card-title primary-title>
        <div class="title">{{title}}</div>
      </v-card-title>
      <v-card-text v-if="graphdata">
        <dist-chart class="dist-chart" :chartdata="graphdata" :color="color"></dist-chart>
      </v-card-text>
    </v-card>
</template>
<script>
import AuxChart from './AuxChart';
import DistribuicaoChart from './DistribuicaoChart'
export default {
  components: {
    'dist-chart' : DistribuicaoChart,
  },
  name : 'card-dist',
  props : ['labels', 'title', 'graphdata', 'color'],
  data () {
    return {
      
    };
  },
  created: function() { 
    
  },
  methods: {
    
  }
};
</script>
<style scoped lang="css">
  .dist-chart {
    position: relative;
    height: 300px;
  }
</style>
